import {Action} from '@ngrx/store';
import {ContactInfoDTO} from '@staff-app/models/termStaffContactInfoDTO';

export enum ContactInfoActionTypes {
  GetContactInfo = '[ContactInfo] Get Contact Info',
  GetContactInfoSuccessful = '[ContactInfo] Get Contact Info Successful',
  SaveContactInfo = '[ContactInfo] Save Contact Info',
  SaveContactInfoSuccessful = '[ContactInfo] Save Contact Info Successful',
  NavigateAway = '[ContactInfo] Navigate Away'
}
export class GetContactInfo implements Action {
  readonly type = ContactInfoActionTypes.GetContactInfo;

  constructor(public payload: number) {}
}
export class GetContactInfoSuccessful implements Action {
  readonly type = ContactInfoActionTypes.GetContactInfoSuccessful;

  constructor(public payload: any) {}
}
export class SaveContactInfo implements Action {
  readonly type = ContactInfoActionTypes.SaveContactInfo;

  constructor(public payload: ContactInfoDTO, public isEditMode = false) {}
}
export class SaveContactInfoSuccessful implements Action {
  readonly type = ContactInfoActionTypes.SaveContactInfoSuccessful;

  constructor(public payload: any) {}
}
export class NavigateAway implements Action {
  readonly type = ContactInfoActionTypes.NavigateAway;

  constructor() {}
}
export type ContactInfoActions =
  | GetContactInfo
  | GetContactInfoSuccessful
  | SaveContactInfo
  | SaveContactInfoSuccessful
  | NavigateAway;
